<template>
	<div class="question-container" style="border: 1px solid #edeff2">
		<div class="question-type">出生日期</div>
		<div class="title-view" :style="{ marginRight: '' }">
			<p style="color: #4c4a56">
				<span v-if="dataObj.isMust === 1" class="asterisk">*</span>
				{{ `${index + 1}、` }}
				<span style="color: #4c4a56">
					{{ `${dataObj.caseProblem}` }}
				</span>
			</p>
		</div>

		<div class="question-images">
			<div v-for="(item, idx) in images" :key="idx" style="margin-top: 10px; position: relative">
				<img :src="item" mode="widthFix" style="width: 100%" />
			</div>
		</div>

		<div class="select-view">
			<p style="font-size: 14px; color: #2b2f36; word-break: break-all">
				{{ answerText || '请选择出生日期' }}
			</p>
			<i class="el-icon-date" size="16px"></i>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			params: {
				type: Object,
				default: {},
			},
		},
		data() {
			return {
				dataObj: {},
				answerObj: {},
				index: 0,
				list: [],
				count: 3,
				isMultiple: true,
				images: [],
				rules: [],
				answerText: '',
			};
		},
		watch: {
			params: {
				handler(newVal) {
					this.dataObj = newVal.data;
					this.index = newVal.index;
					this.images = JSON.parse(newVal.data.caseProblemImg || '[]');
					this.list = JSON.parse(newVal.data.chooseList || '{"list":[]}').list;

					if (newVal.answer && Array.isArray(newVal.answer.answer) && newVal.answer.answer.length > 0) {
						this.answerText = newVal.answer.answer[0].context || '';
					} else {
						this.answerText = '';
					}
				},
				deep: true,
				immediate: true,
			},
		},
	};
</script>

<style scoped>
	.select-view {
		width: 100%;
		min-height: 44px;
		background-color: #f9f9f9;
		border-radius: 3px;
		margin-top: 12px;
		padding: 0 12px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border: 1px solid #ededed;
	}
</style>


// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewBDQ.vue